// extracted by mini-css-extract-plugin
export var aircallIframe = "_jm-3";
export var fabContainer = "_jm-5";
export var fabRinging = "_jm-6";
export var loadingOverlay = "_jm-4";
export var pulse = "_jm-7";
export var widgetContent = "_jm-2";
export var widgetPanel = "_jm-0";
export var widgetPanelExpanded = "_jm-1";